module.exports = __webpack_public_path__ + "static/media/300-hours-EN.a68547bc.png";